// @flow

import type { ReportingParametersState } from "./types";

export const setLoading = (state: ReportingParametersState) => ({ payload }: Object) => {
  ++state.requestsInProgress;
  return state;
};

export const stopLoading = (state: ReportingParametersState) => ({ payload }: Object) => {
  state.requestsInProgress <= 0 ? 0 : --state.requestsInProgress;
  return state;
};

export const onError = (state: ReportingParametersState) => ({ payload }: Object) => {
  state.error = payload;
  state.requestsInProgress <= 0 ? 0 : --state.requestsInProgress;
  return state;
};

export const onGetReportingParametersSuccess = (state: ReportingParametersState) => ({
  payload,
}: Object) => {
  state.error = null;
  state.requestsInProgress <= 0 ? 0 : --state.requestsInProgress;
  state.data = payload;
  return state;
};

export const onGetReportingParametersError = (state: ReportingParametersState) => ({
  payload,
}: Object) => {
  state.requestsInProgress <= 0 ? 0 : --state.requestsInProgress;
  state.error = payload;
  return state;
};

export const onUpdateReportingParametersSuccess = (state: ReportingParametersState) => ({
  payload,
}: Object) => {
  state.error = null;
  state.requestsInProgress <= 0 ? 0 : --state.requestsInProgress;
  state.data = payload;
  return state;
};

export const onGetReportingParametersSchemaSuccess = (state: ReportingParametersState) => ({
  payload,
}: Object) => {
  state.error = null;
  state.schema = payload;
  state.requestsInProgress <= 0 ? 0 : --state.requestsInProgress;
  return state;
};

export const onGetReasonsToBeExcludedSuccess = (state: ReportingParametersState) => ({
  payload,
}: Object) => {
  state.error = null;
  state.reasonsToBeExcluded = payload;
  state.requestsInProgress <= 0 ? 0 : --state.requestsInProgress;
  return state;
};

export const onGetReasonsToBeExcludedSchemaSuccess = (state: ReportingParametersState) => ({
  payload,
}: Object) => {
  state.error = null;
  state.reasonsToBeExcludedSchema = payload;
  state.requestsInProgress <= 0 ? 0 : --state.requestsInProgress;
  return state;
};

export const onToggleReasonsToBeExcludedModal = (state: ReportingParametersState) => ({
  payload,
}: Object) => {
  state.modals.reasonsToBeExcluded.visible = payload
    ? payload
    : !state.modals.reasonsToBeExcluded.visible;
  return state;
};

export const onToggleDeleteReasonToBeExcludedConfirmModal = (state: ReportingParametersState) => ({
  payload,
}: Object) => {
  state.modals.deleteReasonToBeExcludedConfirm.visible = payload
    ? payload
    : !state.modals.deleteReasonToBeExcludedConfirm.visible;
  return state;
};

export const onSetEditReasonToBeExcluded = (state: ReportingParametersState) => ({
  payload,
}: Object) => {
  state.editReasonToBeExcluded = payload;
  return state;
};

export const onToggleScheduledReportsWarningModal = (state: ReportingParametersState) => ({
  payload,
}: Object) => {
  state.modals.scheduledReportsWarning.visible = payload
    ? payload
    : !state.modals.scheduledReportsWarning.visible;
  return state;
};
